const Primary = {
  primary: {
    main: '#0C41C9',
    light: '#5B7FFF',
    dark: '#1C1F4C',
    '10': '#1C1F4C',
    '20': '#19316F',
    '30': '#002B9B',
    '40': '#0C41C9',
    '50': '#124EDE',
    '60': '#2E64F0',
    '70': '#5B7FFF',
    '80': '#8DA6FF',
    '90': '#B2C8FF',
    '95': '#D8E3FF',
    '99': '#ECF1FF',
    '100': '#F5F8FF',
  },
};

export default Primary;
